import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Avatar, Dropdown, Space, Typography, type MenuProps } from 'antd';
import { useNavigate } from 'react-router';
import { useSession } from '../features/auth/useSession';
import { logout } from '../features/auth/api';

/** Header, right side: username + a "Deconectare" dropdown item. */
export function UserMenu() {
  const { data: user } = useSession();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.clear();
      navigate('/login', { replace: true });
    },
  });

  const items: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Deconectare',
      onClick: () => mutation.mutate(),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Space style={{ cursor: 'pointer' }}>
        <Avatar size="small" icon={<UserOutlined />} />
        <Typography.Text>{user?.username}</Typography.Text>
      </Space>
    </Dropdown>
  );
}
